import { render, staticRenderFns } from "./distributorOrder.vue?vue&type=template&id=584a1024&scoped=true&"
import script from "./distributorOrder.vue?vue&type=script&lang=js&"
export * from "./distributorOrder.vue?vue&type=script&lang=js&"
import style0 from "./distributorOrder.vue?vue&type=style&index=0&id=584a1024&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a1024",
  null
  
)

export default component.exports